import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "@idw-types/state/application-state";
import { refreshAxnAdminConfigReduxRequest } from "@redux-requests/axn-admin-config";
import { ButtonWithSpinner } from "../../common/button-with-spinner/button-with-spinner";
import { ContentPageHeader } from "../../common/content-page-header/content-page-header";
import { LoadingIndicator } from "../../common/loading-indicator/loading-indicator";
import { RefreshResultsContainer } from "../refresh-results-container/refresh-results-container";
import { CardContainer } from "../../common/card-container/card-container";
import { resources } from "@constants/hardcoded-strings";
import { ContentPageBody } from "../../common/content-page-body/content-page-body";
import { ButtonTypes } from "@enums/button-types";

export const AxnAdminConfigContainer = () => {
    const dispatch = useDispatch();
    const { isRefreshing, refreshResults, lastRefreshDate } = useSelector((state: ApplicationState) => ({
        isRefreshing: state.axnAdminConfig.isRefreshing,
        refreshResults: state.axnAdminConfig.refreshResults,
        lastRefreshDate: state.axnAdminConfig.lastRefreshDate
    }));

    const onClickRefreshConfig = () => {
        refreshAxnAdminConfigReduxRequest(dispatch)();
    };

    const headerButton = useMemo(() => {
        return (
            <ButtonWithSpinner
                id="axn-admin-config-refresh-button"
                onClick={onClickRefreshConfig}
                disabled={isRefreshing}
                variant="primary"
                label={resources.common.buttons.refresh.label}
                type={ButtonTypes.BUTTON}
            />
        );
    }, [isRefreshing]);

    return (
        <CardContainer>
            <ContentPageHeader title={resources.pages.axnAdminConfig.header} headerButton={headerButton} />
            <ContentPageBody isMaxWidth={true}>
                {!isRefreshing && refreshResults && (
                    <RefreshResultsContainer refreshResults={refreshResults} lastRefreshDate={lastRefreshDate} />
                )}
                {isRefreshing && (
                    <LoadingIndicator title={resources.pages.axnAdminConfig.loadingIndicatorText} />
                )}
            </ContentPageBody>
        </CardContainer>
    );
};